export type IGotToPreviousPage = (button: IjQueryElmOrHtmlElm, theForm: HTMLFormElement) => void;

export function gotToPreviousPage(button: IjQueryElmOrHtmlElm, theForm: HTMLFormElement): void {
  const $button = $(button) as IjQueryElm;
  window.DexeroCoreApp.animateButton($button);
  theForm.direction.value = 'backward';
  theForm.submit();
}
